import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'

import { CompAudioWrapperCore } from '../core/audio/wrapper'
import { CompAudio } from './CompAudio'

/**
 * CompAudioWrapper
 */
function CompAudioWrapper() {
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // action
  const actionContext = useBuilderActionContextV2()

  return (
    <CompAudioWrapperCore infos={infosProps} action={actionContext}>
      {(props) => <CompAudio {...props} />}
    </CompAudioWrapperCore>
  )
}


export default CompAudioWrapper